module.exports = __webpack_public_path__ + "static/media/smallThumbsDownNew.e0e1bd56.svg";